import { render } from "./ModalAuth.vue?vue&type=template&id=4d5ab156&scoped=true"
import script from "./ModalAuth.vue?vue&type=script&lang=js"
export * from "./ModalAuth.vue?vue&type=script&lang=js"

import "./ModalAuth.vue?vue&type=style&index=0&id=4d5ab156&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\wwwda\\OneDrive\\Desktop\\проекты-и-учебные-файлы-front\\pizzares\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d5ab156"]])

export default __exports__